import React from 'react';
import {useTranslation} from 'react-i18next';
import {normalizeLanguage} from './languages';
import catalog from './source-catalog.json';
import ui from './ui-catalog.json';
import reviewed from './reviewed-catalog.json';
import './config';

const core={};
Object.keys(ui).forEach(language=>{
 core[language]={};Object.keys(ui['zh-Hant']).forEach(key=>{core[language][ui['zh-Hant'][key]]=ui[language][key];});
});
const own=(object,key)=>Object.prototype.hasOwnProperty.call(object,key);
const placeholders=text=>(text.match(/\{\{v[0-9]+\}\}/g)||[]).sort().join('|');
export function sdkTranslation(source,language){
 if(typeof source!=='string')return source;
 const locale=normalizeLanguage(language);
 if(locale==='zh-Hant')return source;
 const lookup=text=>own(reviewed[locale]||{},text)?reviewed[locale][text]:own(core[locale]||{},text)?core[locale][text]:own(catalog[locale]||{},text)?catalog[locale][text]:null;
 let translated=lookup(source);
 if(!translated){
  const trimmed=source.trim(),value=lookup(trimmed);
  if(value)translated=source.slice(0,source.indexOf(trimmed))+value+source.slice(source.indexOf(trimmed)+trimmed.length);
 }
 return typeof translated==='string'&&(translated.trim()||own(reviewed[locale]||{},source))&&placeholders(translated)===placeholders(source)?translated:source;
}
export function sdkMessageParts(source,values,language){
 const translated=sdkTranslation(source,language);
 // React renders values as data/nodes, never as translated HTML or executable markup.
 return translated.split(/(\{\{v[0-9]+\}\})/g).map(part=>{
  const match=/^\{\{(v[0-9]+)\}\}$/.exec(part);
  return match&&own(values||{},match[1])?values[match[1]]:part;
 });
}
export function SdkText({text}){
 const {i18n}=useTranslation('translations');
 return <>{typeof text==='string'?sdkTranslation(text,i18n.language):text}</>;
}
export function SdkMessage({source,values}){
 const {i18n}=useTranslation('translations');
 return <>{sdkMessageParts(source,values,i18n.language).map((part,index)=>React.isValidElement(part)?React.cloneElement(part,{key:'slot-'+index}):part)}</>;
}
export const sdkTextElement=text=>React.createElement(SdkText,{text});
export const sdkMessageElement=(source,values)=>React.createElement(SdkMessage,{source,values});

function translateProperty(value,templates,language){
 if(typeof value!=='string')return value;
 const exact=sdkTranslation(value,language);
 if(exact!==value)return exact;
 for(const source of templates||[]){
  // Templates come from the exact authored display expression, not arbitrary UI matching.
  const names=[],pattern=source.split(/(\{\{v[0-9]+\}\})/g).map(part=>{
   const match=/^\{\{(v[0-9]+)\}\}$/.exec(part);
   if(match){names.push(match[1]);return '([\\s\\S]*?)';}
   return part.replace(/[.*+?^${}()|[\]\\]/g,'\\$&');
  }).join('');
  const match=new RegExp('^'+pattern+'$').exec(value);
  if(match){const values={};names.forEach((name,index)=>{values[name]=match[index+1];});return sdkMessageParts(source,values,language).join('');}
 }
 return value;
}
function SdkProperties({element,properties}){
 const {i18n}=useTranslation('translations'),changes={};
 Object.keys(properties).forEach(key=>{changes[key]=translateProperty(element.props[key],properties[key],i18n.language);});
 return React.cloneElement(element,changes);
}
function SdkDisplay({text,templates}){
 const {i18n}=useTranslation('translations');
 return <>{translateProperty(text,templates,i18n.language)}</>;
}
export const sdkDisplayElement=(text,templates=[])=>React.createElement(SdkDisplay,{text,templates});
export function localizeSdkElement(element,properties){
 return React.createElement(SdkProperties,{key:element.key,element,properties});
}
